<template>
	<div id="transcriptsDashboard" class="row no-bottom-margin grey lighten-5">
		<div class="loader-container" v-if="!ready">
				<div 
				class="preloader-wrapper small active">
				<div class="spinner-layer spinner-blue-only">
				<div class="circle-clipper left">
					<div class="circle"></div>
				</div><div class="gap-patch">
					<div class="circle"></div>
				</div><div class="circle-clipper right">
					<div class="circle"></div>
				</div>
				</div>
				</div>
			</div>
		<div id="eStateHolder" v-else-if="ready && items.length < 1">
			<empty-state
        :show-button="true">
				<template #header>{{timeOfDay}} {{user.name}}</template>
				<template #content>
					<div>
						You currently have no records in the list please select create a record below to begin
					</div>
				</template>
				<template #action>
          <router-link :to="{name:'new_record'}" class="btn-medium btn indigo accent-4 white-text">Create New Record</router-link>
				</template>
			</empty-state>
		</div>

		<learners-bg data-title="Transcripts Listing" data-height="300">
			<div class="row">
				<div class="col s12 site-max">
					<div class="col s6 m3" v-for="(re, io) in report" :key="io+3 *1.33">
					<div class="card waves-effect waves-block" @click="$_setFilter(re.key)" >
					<div class="card-content">
						<div :class="statusColor(re.key)" style="height: 4px; margin-bottom: 8px; width: 100px">&nbsp;</div>
						<div class="report-cols" >
							<div class="label-field" style="font-weight:600">{{re.label}}</div>
							<div class="value-field" style="font-size: 18px;" >{{re.number}}</div>
						</div>
					</div>
				</div>
				</div>
				</div>
			</div>

		</learners-bg>
			<div class="col s12 ">    
			<div class="col s12 site-max listing-view">
            <div class="col s12">
							<search-field @search="$_searchFilter($event)" class="left" style="width: 100%"/>
            <div class="clear"></div>
					<!-- 	<div class="page-meta">Transcript Requests</div> -->
						</div>
						<div class="col s12 m4 textCaps">
							<select-field
									class="left "
									:show-label="true"
									:currentValue="filterBy"
									clear-prop="none"
									data-source="code"
									ref="filterBy"
									@update="filterBy = $event.values"
									:data-options="{
										icon: {
											active: false,
											value: 'sort'
										},
										v: true,
										type: 'select',
										label: 'Filter By Statis',
										values: filterBy,
										propName: 'status',
										options: ['none','not-started', 'on-hold', 'complete', 'pending']
									}"
								>
								<span></span>
							</select-field>
						</div>
						<div class="col input-field right right-align">
								<router-link  :to="{name:'new_entry'}"  class="btn waves-effect right white-text"> <i class="material-icons left white-text">launch</i>Add Request</router-link>
						</div>
						<div style="width:100%; height:1px; clear:both;"></div>
						<div class="row flex wrap-items" style="padding: 12px;">
							<div class="col s12 m6 l4" v-for="item in mappedItems" :key="item.id">
								<div class="card hoverable listing">
									<div class="card-content">
										<div class="date-recieved" v-html="$_formatDate(item.date, 'DD MMM, YYYY')"></div>
											<span class="right badge new " :class="statusColor(item.acf.status)" :data-badge-caption="item.acf.status"></span>
										<router-link class="grey-text text-darken-4 card-title" :to="{name:'view_entry',params: {id: item.id}}" v-html="item.title.rendered"></router-link>
										<div class="card-title-new left" v-html="item.acf.case_number"></div>
										<div class="clear"></div>
										<div class="rqp" v-html="item.acf.requesting_party"></div>
										<blockquote class=""> 
											<div class="item-date" v-if="item.acf.logs && item.acf.logs.length > 0">
												{{$_formatDate(item.acf.logs[0].date, 'DD-MM-YYYY: hh:mm a')}}<br>
											</div>
											{{item.acf.logs && item.acf.logs.length > 0 ? item.acf.logs[0].message : ''}}
										</blockquote>
										<div class="clear"></div>
									</div>
									<div class="card-action">
									
									<router-link :to="{name:'view_entry',params: {id: item.id}}" class="btn-flat waves-effect  indigo-text text-accent-4">
										View 
									</router-link>
									<router-link 
									v-if="user && user.acf.role && user.acf.role === 'admin'"
									:to="{name:'view_entry',params: {id: item.id}, query:{state:'edit'}}" class="btn-flat waves-effect grey-text text-darken-4">
									edit
									</router-link>
								
									<button @click="$_deleteTranscript(item.id)" class="btn-flat waves-effect btn-small btn-floating grey-text text-darken-3 right">
										<i class="material-icons-outlined grey-text text-darken-2">delete</i>
									</button>
									</div>
								</div>
							</div>
						
						</div>
            <div class="clear"></div>
							<infinite-loading v-if="!fetching && shouldFetch" @infinite="getEntries(true)"></infinite-loading> 
					<div class="test transparent hide">loading</div>
          </div>
			</div>
	
		<div class="pickers" id="pickerContainer">
			
		</div>
		<!-- diglog  Modal -->
    <div class="dialog" ref="dialogComponent"></div>
    <!-- block list Modal -->
		<router-view />
	</div>
</template>
<script>
import core from '@/functions'
import learnersBg from '@/components/learnersBg.component'
import InfiniteLoading from 'vue-infinite-loading'
import dialogComponent from '@/components/dialog.component'
import contentService from '@/services/contentService'
import searchField from '@/components/searchField.component'
import estate from '@/assets/estate.svg'
import Vue from 'vue'
import { mapState } from 'vuex'
import selectField from "@/components/editing/selectField.component"
import emptyState from '@/components/emptyState.component'
export default {
	name: 'tranScripts',
	components: {
		emptyState,
		selectField,
		searchField,
		InfiniteLoading,
		learnersBg,
		// eslint-disable-next-line vue/no-unused-components
		dialogComponent,
	},
	data () {
		return {
			estate,
			filterBy:'none',
			searchFilter: '',
			fetching: false, 
			shouldFetch:false,
      items: [],
			ready:false,
			
			pagination: {
        page: 1,
        per: 100,
				totalItems: 0,
				totalPages: 0,
      }
		};
	},
	mounted() {
	
    this.getEntries()
	},
	computed: {
		...mapState({
		user: state => state.user,
		/*	authUser: state => state.authUser,
			users:state=> state.record.users,
			companies:state=> state.record.companies */
		}),
		currentRoute:{
			get(){
				return this.$route.name
			}
		},
		report:{
			get () {
				let notStarted =  this.items.filter(x => x.acf.status === 'not-started')
				let completed = this.items.filter(y => y.acf.status === 'complete')
				let pending = this.items.filter(y => y.acf.status === 'pending' || y.acf.status === 'on-hold')
				let unresolved = this.items.filter(y => y.acf.status === 'unresloved')
				return {
					not_started:{
						label:"Not yet started",
						value: notStarted,
						key:'not-started',
						number: notStarted.length
					},
					completed: {
						label:"Complete",
						value: completed,
						key:'complete',
						number: completed.length
					},
					pending: {
						label:"Pending / Onhold",
						value: pending,
						key:'pending',
						number: pending.length
					},
					unresolved: {
						label:"Unresolved",
						value: unresolved,
						key:'unresloved',
						number: unresolved.length
					}
				}
			}
		},
		mappedItems : {
			get () {
			let arr = this.filterBy === 'none'
			? this.items 
			: this.items .filter(a => a.acf.status === this.filterBy)
			return arr
						.filter(b => core.createFieldsText([b.acf.case_name, b.title.rendered, b.acf.name, b.acf.appearances, b.acf.status]).replace(/  +/g, ' ')
						.toLowerCase()
						.includes(this.searchFilter.replace(/  +/g, ' ').toLowerCase()))
						
			}
		},
		timeOfDay: function() {
			let today = new Date();
			let curHr = today.getHours();
			if (curHr < 12) {
				return "Good Morning";
			} else if (curHr < 18) {
				return "Good Afternoon";
			} else {
				return "Good Evening";
			}
		},
	},
	methods: {
		$_searchFilter($event) {
			this.searchFilter = $event
		},
		$_setFilter (e){
			this.filterBy = e
				setTimeout(() => {
			this.$refs.filterBy.selectInstances.destroy()
			this.$refs.filterBy.$_initFormFields()
				}, 100);
			
		},
		statusColor(s){
		return s === 'not-started'
				? 'indigo accent-4'
				: s === 'on-hold'
					? 'yellow darken-2 brown-text'
					: s === 'pending'
						? 'yellow darken-2 grey-text text-darken-3'
						: s === 'complete'
							? 'green accent-4'
							: 'red white-text'
		},
		$_formatDate(date, format){
			return core.dateFormat(new Date(date), format)
    },
    getEntries (g) {
		this.fetching = true
    let query = {per_page: this.pagination.per, page: g ? this.pagination.page + 1 : 1}
      contentService.getTranscripts({q:query})
        .then(res => {
					this.pagination.totalItems = res.headers['x-wp-total']
					this.pagination.totalPages = res.headers['x-wp-totalpages']
          ///this.items = res.data 
					this.shouldFetch = false
					this.fetching = false
					this.pagination.page = query.page
				this.items = [...this.items, ...res.data]
				if (!this.ready) this.ready = true 
				if (parseInt(this.pagination.totalPages) > 1 && this.pagination.page !== parseInt(this.pagination.totalPages)) {
        setTimeout(() => {
          this.shouldFetch = true
        }, 1000)
      }    
        })
    },
		dialogMessages(data) {
      let ComponentClass = Vue.extend(dialogComponent);
      let instance = new ComponentClass({
        propsData: data
      });
      let link = instance.$createElement("div", {
        attrs: {
          class: "context"
        },
        domProps: {
          innerHTML: data.message
        }
      });

      instance.$slots.default = [link];
      instance.$slots["title"] = [data.title];
      instance.$mount(); // pass nothing
      this.$refs.dialogComponent.appendChild(instance.$el);
    },
		$_deleteTranscript(id){
		let data = {
				title:'Delete Entry',
        message: "Are you sure you want to delete this record?",
        buttons: [
          {
            id: 0,
            value: "cancel",
            action: () => {},
            close: true
          },
   
          {
            id: 2,
            value: "Delete",
            action: () => {
						contentService.deleteTranscript(id)
							.then(res=>{
								if(res.data.id){
						//			this.$store.commit('DELETE_RECORD', id)
								let record = 	this.items.findIndex(x => x.id === id)
								this.items.splice(record, 1)
								core.toastMessage('Successfully deleted record')
								}
							})
            },
            close: true
          }
        ]
      };
			this.dialogMessages(data);
		},
	}
};
</script>
<style scoped lang="scss">
div#transcriptsDashboard {
	min-height: 80vh;
	position: relative;
	@media screen and (min-width: 1024px) {
		width: 100%;
		padding-left: 300px;
	}
	#eStateHolder {
		left: 50%;
		top: 50%;
		position: absolute;
		transform: translate(-50%, -50%);
		@media screen and (min-width: 1024px) {
			transform: translate(calc(-50% + 150px), -50%);
		}
	}
	.title-section {
		font-size: 24px;
		line-height: 1.5;
		margin: 12px 0px 12px 0px;
	}
	.page-meta {
		font-size: 24px; 
		line-height: 1.3;
		margin: .75rem 0;
	}
	.clearbtn {
    position: absolute;
    right: 9px;
    top: 16px;
    cursor: pointer;
			i {
        font-size: 18px;
      }
  }
	
	.tsc {
		position: relative;
		&::before {
			content: "search";
			font-family: "Material Icons";
			font-size: 21px;
			position: absolute;
			top: 10px;
			color: #8f8f8f;
			left: 12px;
		}
	}
	.circle-tar {
		border-radius:50%;
		width:50px;
		height:50px;
	}
button.btn.cs-btn {
    padding: 0px 4px;
    height: 30px;
    line-height: 29px;
    margin-right: 5px;
}
.loader-container {
		position: fixed;
		top:50%;
		left:50%;
		transform:translate(-50%,-50%);
			@media screen and (min-width:1024px){
				left:calc(50% + 300px);
				transform:translate(calc(-50% - 250px),-50%);
			}
	}
  .listing-view {
    margin-top:24px;
  }
  .card.listing {
    border-radius: 8px;
		height: calc(100% - 1.5rem);
    overflow: hidden;
		padding-bottom: 60px;
		.card-title {
			font-size: 18px;
			line-height: 1.4;
			font-weight: 400;
			margin: 0px 0 12px 0;
		}
    .card-content {
      padding:24px;
    }
    .card-action {
			position: absolute;
			bottom: 0;
			left:0;
			right:0;
			border-top:none;
      padding : 0px 24px 24px 24px;
    }
    blockquote {
      font-size: 13px;
      padding-left: 8px;
      border-left: 4px solid #304ffe;
			letter-spacing: 1px;
      margin: 7px 2px;
    }
  }
  .date-recieved {
    font-size:12px;
  }
	.badge {
		text-transform: capitalize;
	}
}
</style>
<style lang="scss">
	.textCaps, .textCaps input.select-dropdown.dropdown-trigger {
		text-transform: capitalize !important;
	}
</style>